import { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useSelector } from "react-redux";
import AssetsService from "../../../../../services/AssetsService";
import DeleteModal from "../../../../common/DeleteModal";
import { Translate } from "../../../../Enums/Tranlate";

const CardItem = ({
	item,
	setItem,
	index,
	setAddModal,
	setView,
	setShouldUpdate,
}) => {
	const [deleteModal, setDeleteModal] = useState(false);
	const Auth = useSelector((state) => state.auth?.auth);
	const lang = useSelector((state) => state.auth?.lang);
	const isExist = (data) => Auth?.admin?.admin_roles?.includes(data);
	const assetsService = new AssetsService();

	return (
		<tr key={index} className="text-center">
			<td>{item?.name}</td>
			<td>{item?.serialNumber || "-"}</td>
			<td>
				<div
					style={{
						display: "grid",
						gridTemplateColumns: "auto auto auto",
						gap: "8px",
					}}>
					{!!item?.categories?.length
						? item?.categories?.map((res) => {
								return (
									<span className="badge bg-primary text-white">
										{res?.name}
									</span>
								);
						  })
						: "-"}
				</div>
			</td>
			<td>
				{item?.type === "WITH_SERIAL_NUMBER"
					? `${Translate[lang].with} ${Translate[lang].serial_number}`
					: item?.type === "WITH_CATEGORIES"
					? `${Translate[lang].with} ${Translate[lang].items}`
					: `${Translate[lang].with} ${Translate[lang].serial_number} ${Translate[lang].and} ${Translate[lang].items}`}
			</td>
			{/* {isExist("view_assets") &&  */}
			<td>
				<i
					className="la la-eye cursor-pointer"
					onClick={() => {
						setItem(item);
						setAddModal(true);
						setView(true);
					}}
					style={{
						fontSize: "27px",
						color: "#666",
					}}></i>
			</td>
			{/* } */}
			<td>
				{/* {(isExist("edit_assets") || isExist("delete_assets") ) &&  */}
				<Dropdown>
					<Dropdown.Toggle className="light sharp i-false">
						<i className="la la-ellipsis-v" style={{ fontSize: "27px" }}></i>
					</Dropdown.Toggle>
					<Dropdown.Menu>
						{/* {isExist("edit_assets") && ( */}
						<Dropdown.Item
							onClick={() => {
								setItem(item);
								setAddModal(true);
							}}>
							<i className="la la-edit"></i> {Translate[lang]?.edit}
						</Dropdown.Item>
						{/* )}
						{isExist("delete_assets") && ( */}
						<Dropdown.Item onClick={() => setDeleteModal(true)}>
							<i className="la la-trash"></i> {Translate[lang]?.delete}
						</Dropdown.Item>
						{/* )} */}
					</Dropdown.Menu>
				</Dropdown>
				{/* } */}
			</td>
			{deleteModal && (
				<DeleteModal
					open={deleteModal}
					titleMsg={item?.name}
					deletedItem={item}
					modelService={assetsService}
					onCloseModal={setDeleteModal}
					setShouldUpdate={setShouldUpdate}
				/>
			)}
		</tr>
	);
};
export default CardItem;
